import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

import api from "../../services/api";
import "../Grupos/edicaoGrupo.scss";


function Grupo_edicao() {

  /* =========================================================
     PARAMETROS / NAVEGAÇÃO
     ========================================================= */

  const { id } = useParams();
  const navigate = useNavigate();


  /* =========================================================
     ESTADOS
     ========================================================= */

  const [loadingVeiculos, setLoadingVeiculos] = useState(true);

  const [veiculosOriginais, setVeiculosOriginais] = useState([]);

  const [notificacoesPredefinidas, setNotificacoesPredefinidas] =
    useState([]);

  const [notificacoesSelecionadas, setNotificacoesSelecionadas] =
    useState([]);

  const [searchDisponiveis, setSearchDisponiveis] = useState("");
  const [searchSelecionados, setSearchSelecionados] = useState("");

  const [values, setValues] = useState({});

  const [grupoOriginal, setGrupoOriginal] = useState({
    nome: "",
    veiculos: [],
  });

  const [permitirAdicionar, setPermitirAdicionar] =
    useState(false);



  const [nomeOriginal, setNomeOriginal] =
    useState("");

  const [confirmadoNome, setConfirmadoNome] =
    useState(false);

  const [backupSelecionadas, setBackupSelecionadas] =
    useState([]);

  const [backupPredefinidas, setBackupPredefinidas] =
    useState([]);

  const [confirmouRemocao, setConfirmouRemocao] =
    useState(false);


  /* =========================================================
     CONFIGURAÇÕES
     ========================================================= */

  const MAX_NOME = 50;



  //=========================================================
  // SEARCH SELECIONADOS
  //=========================================================
  const filtradosSelecionados = notificacoesSelecionadas.filter((notificacao) => {
    const placa = notificacao.split(" | ")[0].trim();

    const veiculoCompleto = notificacoesPredefinidas.find(
      (v) =>
        v.split(" | ")[0].trim().toUpperCase() ===
        placa.toUpperCase()
    );

    const descricao = veiculoCompleto
      ? veiculoCompleto.split(" | ").slice(1).join(" | ")
      : "";

    const textoBusca = `${placa} ${descricao} ${notificacao}`
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    const busca = searchSelecionados
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

    return textoBusca.includes(busca);
  });


  /* =========================================================
     BUSCAR VEÍCULOS
     ========================================================= */


  useEffect(() => {
    async function fetchVeiculos() {
      try {
        setLoadingVeiculos(true);

        const cliente = localStorage.getItem("id");

        if (!cliente) {
          throw new Error("ID do cliente não encontrado no localStorage.");
        }

        const { data } = await api.get("/equipamentos", {
          headers: {
            typo: cliente
          }
        });

        const equipamentos = Array.isArray(data)
          ? data
          : [];

        const lista = equipamentos.map(
          (v) => `${v.placa} | ${v.nome}`
        );

        setVeiculosOriginais(lista);
        setNotificacoesPredefinidas(lista);

      } catch (error) {
        console.error(
          "Erro ao carregar veículos:",
          error.response?.data || error
        );

        toast.error("Erro ao carregar veículos");

      } finally {
        setLoadingVeiculos(false);
      }
    }

    fetchVeiculos();
  }, []);


  /* =========================================================
     BUSCAR GRUPO
     ========================================================= */

  useEffect(() => {

    async function fetchGrupo() {

      try {

        const { data } =
          await api.get(`/gruposss/${id}`, {
            headers: {
              typo: localStorage.getItem("id"),
            },
          });


        /* -----------------------------------------------------
           DADOS DO GRUPO
           ----------------------------------------------------- */

        setGrupoOriginal({
          nome: (data.nome || "").trim(),

          veiculos: data.veiculos
            ? data.veiculos
              .split(",")
              .map((v) =>
                v.replace(/'/g, "").trim()
              )
              .filter(Boolean)
            : [],
        });


        /* -----------------------------------------------------
           CAMPOS
           ----------------------------------------------------- */

        setValues({
          nome: data.nome,
          icone: data.icone,
        });


        /* -----------------------------------------------------
           VEÍCULOS SELECIONADOS
           ----------------------------------------------------- */

        const selecionados = data.veiculos
          ? data.veiculos
            .split(",")
            .map((v) =>
              v.replace(/'/g, "").trim()
            )
            .filter(Boolean)
          : [];


        setNotificacoesSelecionadas(
          selecionados
        );


        /* -----------------------------------------------------
           VEÍCULOS DISPONÍVEIS
           ----------------------------------------------------- */

        setNotificacoesPredefinidas(
          veiculosOriginais.filter(
            (v) => !selecionados.includes(v)
          )
        );

      } catch (error) {

        console.error(
          "Erro ao carregar grupo:",
          error
        );

        Swal.fire({
          title: "Erro ao carregar grupo",
          text: "Não foi possível buscar os dados.",
          icon: "error",

          background: "#0f172a",
          color: "#fff",

          confirmButtonColor: "#ef4444",

          scrollbarPadding: false,
          heightAuto: false,
        });

      }
    }


    if (veiculosOriginais.length) {
      fetchGrupo();
    }

  }, [id, veiculosOriginais]);


  /* =========================================================
     FILTRO DE VEÍCULOS DISPONÍVEIS
     ========================================================= */

  const placasSelecionadas = new Set(
    notificacoesSelecionadas.map((v) =>
      v.split(" | ")[0].trim().toUpperCase()
    )
  );

  const filterPlaca = notificacoesPredefinidas.filter((v) => {
    const placa = v.split(" | ")[0].trim().toUpperCase();

    return (
      !placasSelecionadas.has(placa) &&
      v.toLowerCase().includes(searchDisponiveis.toLowerCase())
    );
  });


  /* =========================================================
     HANDLE CHANGE
     ========================================================= */

  const handleChange = (e) => {

    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  };


  /* =========================================================
     SELECIONAR VEÍCULO
     ========================================================= */

  const handleSelecionadas = (valor) => {

    setNotificacoesSelecionadas((prev) => [
      ...prev,
      valor,
    ]);

    setNotificacoesPredefinidas((prev) =>
      prev.filter((v) => v !== valor)
    );

  };


  /* =========================================================
     REMOVER VEÍCULO
     ========================================================= */

  const handlePredefinidas = (valor) => {

    setNotificacoesPredefinidas((prev) => [
      ...prev,
      valor,
    ]);

    setNotificacoesSelecionadas((prev) =>
      prev.filter((v) => v !== valor)
    );

  };


  /* =========================================================
     CONFIRMAR REMOÇÃO DE VEÍCULO
     ========================================================= */

  const confirmarRemocaoVeiculo = async (veiculo) => {

    /* -------------------------------------------------------
       SE JÁ CONFIRMOU, REMOVE DIRETO
       ------------------------------------------------------- */

    if (confirmouRemocao) {

      handlePredefinidas(veiculo);

      return;
    }


    /* -------------------------------------------------------
       CONFIRMAÇÃO
       ------------------------------------------------------- */
    const result = await Swal.fire({

      title: "Remover veículos",

      icon: "warning",
      iconColor: "#f59e0b",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.5rem",

      html: `
    <div class="swal-grupo-remover">

      <div class="swal-grupo-remover-description">
        Os veículos selecionados serão removidos
        do grupo atual.
      </div>


      <div class="swal-grupo-remover-box">

        <div class="swal-grupo-remover-icon">
          −
        </div>


        <div class="swal-grupo-remover-content">

          <div class="swal-grupo-remover-label">
            Ação
          </div>

          <div class="swal-grupo-remover-value">
            Remover veículos do grupo
          </div>

        </div>

      </div>


      <div class="swal-grupo-remover-info">
        Apenas os veículos selecionados serão removidos.
        As alterações ainda precisarão ser salvas.
      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Continuar",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#dc3f3f",

      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup: "swal-grupo-remover-popup",

        title: "swal-grupo-remover-title",

        htmlContainer: "swal-grupo-remover-html",

        confirmButton: "swal-grupo-remover-confirm",

        cancelButton: "swal-grupo-remover-cancel",

        actions: "swal-grupo-remover-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,

      heightAuto: false,

    });


    if (result.isConfirmed) {

      setConfirmouRemocao(true);

      handlePredefinidas(veiculo);

    }

  };


  /* =========================================================
     NOME ORIGINAL
     ========================================================= */

  useEffect(() => {

    if (
      values.nome &&
      nomeOriginal === ""
    ) {

      setNomeOriginal(values.nome);

    }

  }, [values.nome, nomeOriginal]);






  /* =========================================================
     CONFIRMAR SELEÇÃO DE TODOS
     ========================================================= */

  const confirmarSelecionarTodos = async (checked) => {

    /* -------------------------------------------------------
       BACKUP DO ESTADO ATUAL
       ------------------------------------------------------- */

    setBackupSelecionadas([
      ...notificacoesSelecionadas,
    ]);

    setBackupPredefinidas([
      ...notificacoesPredefinidas,
    ]);


    /* -------------------------------------------------------
       CONFIRMAÇÃO
       ------------------------------------------------------- */

    const result = await Swal.fire({

      title: checked
        ? "Selecionar todos"
        : "Desfazer seleção",

      icon: "question",
      iconColor: "#38bdf8",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.5rem",

      html: `
    <div class="swal-grupo-selecao">

      <div class="swal-grupo-selecao-description">

        ${checked
          ? "Todos os veículos disponíveis serão adicionados ao grupo."
          : "A seleção atual será restaurada para o estado anterior."
        }

      </div>


      <div class="swal-grupo-selecao-box">

        <div class="swal-grupo-selecao-icon">
          ${checked ? "✓" : "↶"}
        </div>


        <div class="swal-grupo-selecao-content">

          <div class="swal-grupo-selecao-label">
            Ação
          </div>

          <div class="swal-grupo-selecao-value">

            ${checked
          ? "Selecionar todos os veículos"
          : "Restaurar seleção anterior"
        }

          </div>

        </div>

      </div>


      <div class="swal-grupo-selecao-warning">

        ${checked
          ? "Todos os veículos disponíveis entrarão no grupo."
          : "As alterações de seleção serão desfeitas."
        }

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: checked
        ? "Selecionar todos"
        : "Restaurar",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",
      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup: "swal-grupo-selecao-popup",

        title: "swal-grupo-selecao-title",

        htmlContainer: "swal-grupo-selecao-html",

        confirmButton: "swal-grupo-selecao-confirm",

        cancelButton: "swal-grupo-selecao-cancel",

        actions: "swal-grupo-selecao-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,
      heightAuto: false,

    });

    /* -------------------------------------------------------
       CANCELADO
       ------------------------------------------------------- */

    if (!result.isConfirmed) {
      return;
    }


    /* -------------------------------------------------------
       SELECIONAR TODOS
       ------------------------------------------------------- */

    if (checked) {


      const selecionadosUnicos = new Map();

      [
        ...notificacoesSelecionadas,
        ...notificacoesPredefinidas,
      ].forEach((veiculo) => {
        const placa = veiculo
          .split(" | ")[0]
          .trim()
          .toUpperCase();

        if (!selecionadosUnicos.has(placa)) {
          selecionadosUnicos.set(placa, veiculo);
        }
      });

      setNotificacoesSelecionadas(
        [...selecionadosUnicos.values()]
      );

      setNotificacoesPredefinidas([]);


      setNotificacoesPredefinidas([]);

    } else {

      /* -----------------------------------------------------
         RESTAURAR ESTADO
         ----------------------------------------------------- */

      setNotificacoesSelecionadas(
        backupSelecionadas
      );

      setNotificacoesPredefinidas(
        backupPredefinidas
      );

    }

  };


  /* =========================================================
     CONFIRMAR ADIÇÃO DE VEÍCULOS
     ========================================================= */

  const confirmarAdicionarVeiculos = async (e) => {

    if (permitirAdicionar) {
      return;
    }

    e.preventDefault();


    const result = await Swal.fire({

      title: "Adicionar veículos",

      icon: "question",
      iconColor: "#38bdf8",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.5rem",

      html: `
    <div class="swal-grupo-adicionar">

      <div class="swal-grupo-adicionar-description">
        Os veículos selecionados serão adicionados
        ao grupo atual.
      </div>


      <div class="swal-grupo-adicionar-box">

        <div class="swal-grupo-adicionar-icon">
          +
        </div>


        <div class="swal-grupo-adicionar-content">

          <div class="swal-grupo-adicionar-label">
            Ação
          </div>

          <div class="swal-grupo-adicionar-value">
            Adicionar veículos ao grupo
          </div>

        </div>

      </div>


      <div class="swal-grupo-adicionar-info">
        Você poderá remover os veículos posteriormente,
        caso necessário.
      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Adicionar veículos",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",
      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup: "swal-grupo-adicionar-popup",

        title: "swal-grupo-adicionar-title",

        htmlContainer: "swal-grupo-adicionar-html",

        confirmButton: "swal-grupo-adicionar-confirm",

        cancelButton: "swal-grupo-adicionar-cancel",

        actions: "swal-grupo-adicionar-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,
      heightAuto: false,

    });

    if (result.isConfirmed) {

      setPermitirAdicionar(true);


      setTimeout(() => {

        document
          .getElementById(
            "grupo-edicao-select-veiculos"
          )
          ?.focus();

      }, 0);

    }

  };


  /* =========================================================
     SALVAR
     ========================================================= */

  const handleSubmit = async () => {

    try {

      /* =========================================================
         VALIDAÇÃO
         ========================================================= */

      if (
        !values.nome ||
        notificacoesSelecionadas.length === 0
      ) {

        await Swal.fire({

          title: "Campos obrigatórios",

          icon: "warning",
          iconColor: "#f59e0b",

          background: "#0b1722",
          color: "#e8f1f7",

          width: "420px",
          padding: "1.5rem",

          confirmButtonText: "Entendi",
          confirmButtonColor: "#1686bd",

          scrollbarPadding: false,
          heightAuto: false,

          html: `
          <div class="swal-grupo-validacao">

            <div class="swal-grupo-validacao-description">
              Preencha todos os campos obrigatórios
              antes de continuar.
            </div>

          </div>
        `,

          customClass: {

            popup: "swal-grupo-validacao-popup",

            title: "swal-grupo-validacao-title",

            htmlContainer: "swal-grupo-validacao-html",

            confirmButton: "swal-grupo-validacao-confirm",

          },

          buttonsStyling: false,

        });

        return;
      }


      /* =========================================================
         NORMALIZAR NOME
         ========================================================= */

      const nomeAtual =
        (values.nome || "")
          .trim()
          .toLowerCase();


      const nomeOriginalGrupo =
        (grupoOriginal?.nome || "")
          .trim()
          .toLowerCase();


      /* =========================================================
         NORMALIZAR PLACAS ATUAIS
         ========================================================= */

      const placasAtuais =
        [...(notificacoesSelecionadas || [])]
          .map((v) =>
            String(v)
              .trim()
              .toUpperCase()
          )
          .filter(Boolean)
          .sort();


      /* =========================================================
         NORMALIZAR PLACAS ORIGINAIS
         ========================================================= */

      const placasOriginais =
        [...(grupoOriginal?.veiculos || [])]
          .map((v) =>
            String(v)
              .trim()
              .toUpperCase()
          )
          .filter(Boolean)
          .sort();


      /* =========================================================
         COMPARAR
         ========================================================= */

      const mesmasPlacas =
        JSON.stringify(placasAtuais) ===
        JSON.stringify(placasOriginais);


      const houveAlteracao =
        nomeAtual !== nomeOriginalGrupo ||
        !mesmasPlacas;


      /* =========================================================
         NENHUMA ALTERAÇÃO
         ========================================================= */

      if (!houveAlteracao) {

        await Swal.fire({

          title: "Nenhuma alteração",

          icon: "warning",
          iconColor: "#f59e0b",

          background: "#0b1722",
          color: "#e8f1f7",

          width: "500px",
          padding: "1.5rem",

          confirmButtonText: "Entendi",
          confirmButtonColor: "#1686bd",

          scrollbarPadding: false,
          heightAuto: false,

          html: `
          <div class="swal-grupo-sem-alteracao">

            <div class="swal-grupo-sem-alteracao-description">
              Nenhuma alteração foi realizada no grupo.
            </div>


            <div class="swal-grupo-sem-alteracao-box">

              <div class="swal-grupo-sem-alteracao-title">
                Para salvar, altere pelo menos um item
              </div>


              <div class="swal-grupo-sem-alteracao-list">

                <div class="swal-grupo-sem-alteracao-item">
                  <span class="swal-grupo-sem-alteracao-dot"></span>
                  Nome do grupo
                </div>

                <div class="swal-grupo-sem-alteracao-item">
                  <span class="swal-grupo-sem-alteracao-dot"></span>
                  Adicionar veículos
                </div>

                <div class="swal-grupo-sem-alteracao-item">
                  <span class="swal-grupo-sem-alteracao-dot"></span>
                  Remover veículos
                </div>

              </div>

            </div>

          </div>
        `,

          customClass: {

            popup: "swal-grupo-sem-alteracao-popup",

            title: "swal-grupo-sem-alteracao-title-popup",

            htmlContainer: "swal-grupo-sem-alteracao-html",

            confirmButton: "swal-grupo-sem-alteracao-confirm",

            actions: "swal-grupo-sem-alteracao-actions",

          },

          buttonsStyling: false,

        });

        return;
      }


      /* =========================================================
         CONFIRMAR SALVAMENTO
         ========================================================= */

      const confirm = await Swal.fire({

        title: "Salvar alterações",

        icon: "question",
        iconColor: "#38bdf8",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "500px",
        padding: "1.5rem",

        html: `
        <div class="swal-grupo-salvar">

          <div class="swal-grupo-salvar-description">
            Revise os dados abaixo antes de confirmar.
          </div>


          <div class="swal-grupo-salvar-box">

            <div class="swal-grupo-salvar-item">

              <div class="swal-grupo-salvar-label">
                Nome do grupo
              </div>

              <div class="swal-grupo-salvar-name">
                ${values.nome || "Sem nome"}
              </div>

            </div>


            <div class="swal-grupo-salvar-item">

              <div class="swal-grupo-salvar-label">
                Veículos vinculados
              </div>

              <div class="swal-grupo-salvar-count">

                <span>
                  ${notificacoesSelecionadas.length}
                </span>

                ${notificacoesSelecionadas.length === 1
            ? "veículo"
            : "veículos"
          }

              </div>

            </div>

          </div>


          <div class="swal-grupo-salvar-info">
            As alterações serão aplicadas ao grupo
            após a confirmação.
          </div>

        </div>
      `,

        showCancelButton: true,

        confirmButtonText: "Salvar alterações",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#1686bd",
        cancelButtonColor: "#26394a",

        reverseButtons: true,

        focusConfirm: false,

        customClass: {

          popup: "swal-grupo-salvar-popup",

          title: "swal-grupo-salvar-title",

          htmlContainer: "swal-grupo-salvar-html",

          confirmButton: "swal-grupo-salvar-confirm",

          cancelButton: "swal-grupo-salvar-cancel",

          actions: "swal-grupo-salvar-actions",

        },

        buttonsStyling: false,

        scrollbarPadding: false,
        heightAuto: false,

      });


      if (!confirm.isConfirmed) {
        return;
      }


      /* =========================================================
         LOADER
         ========================================================= */

      Swal.fire({

        title: "Salvando alterações...",

        background: "#0b1722",
        color: "#e8f1f7",

        showConfirmButton: false,

        allowOutsideClick: false,
        allowEscapeKey: false,

        scrollbarPadding: false,
        heightAuto: false,

        html: `
        <div class="swal-grupo-salvando">

          <div class="swal-grupo-salvando-spinner"></div>

          <div class="swal-grupo-salvando-text">
            Atualizando grupo...
          </div>

        </div>
      `,

        customClass: {

          popup: "swal-grupo-salvando-popup",

          title: "swal-grupo-salvando-title",

          htmlContainer: "swal-grupo-salvando-html",

        },

        buttonsStyling: false,

      });


      /* =========================================================
         PLACAS
         ========================================================= */

      const placa =
        notificacoesSelecionadas
          .map((v) => `'${v}'`)
          .join(",");


      /* =========================================================
         API ATUALIZAR
         ========================================================= */

      await api.put(`/grupo/${id}`, {
        nome: values.nome,
        icone: values.icone,
        placa,
        veiculos: placa,
        cliente: localStorage.getItem("id"),
        editado_por: localStorage.getItem("clientID"),
      });

      // Avisa a lista que o grupo foi editado
      window.dispatchEvent(
        new Event("grupos-atualizados")
      );



      /* =========================================================
         FECHAR LOADER
         ========================================================= */

      Swal.close();


      /* =========================================================
         VOLTAR
         ========================================================= */

      navigate("/maps/grupos");


      /* =========================================================
         SUCESSO
         ========================================================= */



    } catch (error) {

      /* =========================================================
         ERRO
         ========================================================= */

      console.error(
        "Erro ao atualizar grupo:",
        error
      );

      Swal.close();


      Swal.fire({

        title: "Erro ao atualizar grupo",

        text:
          "Não foi possível salvar as alterações. Tente novamente.",

        icon: "error",
        iconColor: "#ef4444",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "420px",
        padding: "1.5rem",

        confirmButtonText: "Entendi",

        scrollbarPadding: false,
        heightAuto: false,

        customClass: {

          popup: "swal-grupo-erro-popup",

          title: "swal-grupo-erro-title",

          confirmButton:
            "swal-grupo-erro-confirm",

        },

        buttonsStyling: false,

      });

    }

  };


  /* =========================================================
     RENDER
     ========================================================= */

  return (

    <div className="grupo-edicao-page">

      <ToastContainer />


      {/* =====================================================
            CARD
            ===================================================== */}

      <div className="grupo-edicao-card">


        {/* ===================================================
              HEADER
              =================================================== */}

        <div className="grupo-edicao-header">

          <h5 className="grupo-edicao-title">
            Editar Grupo
          </h5>


          <button
            type="button"
            className="grupo-edicao-close"
            onClick={() => navigate(-1)}
            aria-label="Fechar"
          >
            ✕
          </button>

        </div>


        {/* ===================================================
              BODY
              =================================================== */}

        <div className="grupo-edicao-body">

          <form
            className="grupo-edicao-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >


            {/* ===============================================
                  NOME
                  =============================================== */}

            <div className="grupo-edicao-field grupo-edicao-field-full">

              <label className="grupo-edicao-label">
                Nome
              </label>


              <input
                type="text"
                name="nome"
                placeholder="Nome do grupo"
                className="grupo-edicao-input"
                value={values.nome || ""}
                maxLength={MAX_NOME}
                onChange={handleChange}
                required
              />

              <div
                className="grupo-edicao-counter"
                style={{
                  color:
                    MAX_NOME -
                      (values.nome?.length || 0) <=
                      10
                      ? "#ef4444"
                      : "#94a3b8",
                }}
              >
                {MAX_NOME -
                  (values.nome?.length || 0)}{" "}
                caracteres restantes
              </div>

            </div>


            {/* ===============================================
                  BUSCA + TODOS
                  =============================================== */}

            <div className="grupo-edicao-top-row">


              {/* BUSCA DISPONÍVEL */}

              <div className="grupo-edicao-field">

                <label className="grupo-edicao-label">
                  Buscar veículo disponível
                </label>


                <input
                  type="text"

                  className="grupo-edicao-input"

                  placeholder="Buscar por placa ou descrição"

                  value={searchDisponiveis}

                  onChange={(e) =>
                    setSearchDisponiveis(e.target.value)
                  }
                />

              </div>
              {/* BUSCA SELECIONADO*/}

              <div className="grupo-edicao-field">

                <label className="grupo-edicao-label">
                  Buscar veículos selecionados
                </label>


                <input
                  type="text"

                  className="grupo-edicao-input"

                  placeholder="Buscar por placa ou descrição"

                  value={searchSelecionados}

                  onChange={(e) =>
                    setSearchSelecionados(e.target.value)
                  }
                />

              </div>


              {/* TODOS */}

              <div className="grupo-edicao-select-all">

                <label className="grupo-edicao-checkbox-label">

                  <input
                    type="checkbox"

                    className="grupo-edicao-checkbox"

                    checked={
                      notificacoesPredefinidas.length === 0
                    }

                    onChange={(e) =>
                      confirmarSelecionarTodos(
                        e.target.checked
                      )
                    }
                  />

                  <span>
                    Selecionar todos os{" "}
                    <b>Veículos</b>
                  </span>

                </label>

              </div>

            </div>


            {/* ===============================================
                  LISTAS
                  =============================================== */}

            <div className="grupo-edicao-listas">


              {/* =============================================
                    DISPONÍVEIS
                    ============================================= */}

              <div className="grupo-edicao-lista">

                <label className="grupo-edicao-lista-title">
                  Disponíveis
                </label>


                {loadingVeiculos ? (

                  <div className="grupo-edicao-loading">

                    <div className="grupo-edicao-spinner"></div>

                    <span>
                      Carregando veículos...
                    </span>

                  </div>

                ) : (

                  <div
                    id="grupo-edicao-select-veiculos"
                    className="grupo-veiculos-select grupo-edicao-veiculos-select"
                    onMouseDown={confirmarAdicionarVeiculos}
                  >

                    {[...new Map(
                      [...filterPlaca]
                        .map((item) => {
                          const [placa, ...descricao] = item.split(" | ");
                          return {
                            placa: placa.trim(),
                            descricao: descricao.join(" | ").trim(),
                          };
                        })
                        .reduce((mapa, item) => {
                          const chave = item.placa.toUpperCase();
                          const existente = mapa.get(chave);

                          if (!existente || (!existente.descricao && item.descricao)) {
                            mapa.set(chave, item);
                          }

                          return mapa;
                        }, new Map())
                    ).values()]
                      .sort((a, b) =>
                        a.placa.localeCompare(b.placa, "pt-BR", {
                          sensitivity: "base",
                        })
                      )
                      .map(({ placa, descricao }) => {
                        const notificacao = descricao
                          ? `${placa} | ${descricao}`
                          : placa;

                        return (
                          <div
                            key={placa.toUpperCase()}
                            className="grupo-veiculos-option"
                            onClick={() => handleSelecionadas(notificacao)}
                          >
                            <span className="veiculo-placa">{placa}</span>
                            {descricao && (
                              <span className="veiculo-descricao">{descricao}</span>
                            )}
                          </div>
                        );
                      })}

                  </div>

                )}

              </div>


              {/* =============================================
                    SELECIONADOS
                    ============================================= */}

              <div className="grupo-edicao-lista">

                <label className="grupo-edicao-lista-title">
                  Selecionados
                </label>


                <div
                  className="
      grupo-edicao-veiculos-select
      grupo-edicao-veiculos-select-selected
      grupo-veiculos-select
    "
                >
                  {[
                    ...new Map(
                      filtradosSelecionados.map((notificacao) => {
                        const placa = notificacao
                          .split(" | ")[0]
                          .trim()
                          .toUpperCase();

                        return [placa, notificacao];
                      })
                    ).values(),
                  ].map((notificacao) => {
                    const placa = notificacao.split(" | ")[0].trim();

                    const veiculoCompleto = veiculosOriginais.find(
                      (v) =>
                        v.split(" | ")[0].trim().toUpperCase() ===
                        placa.toUpperCase()
                    );

                    const descricao = veiculoCompleto
                      ? veiculoCompleto.split(" | ").slice(1).join(" | ").trim()
                      : notificacao.split(" | ").slice(1).join(" | ").trim();

                    return (
                      <div
                        key={placa}
                        className="grupo-veiculos-option"
                        onClick={() => confirmarRemocaoVeiculo(notificacao)}
                      >
                        <span className="veiculo-placa">
                          {placa}
                        </span>

                        {descricao && (
                          <span className="veiculo-descricao">
                            {descricao}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>

              </div>

            </div>


            {/* ===============================================
                  BOTÕES
                  =============================================== */}

            <div className="grupo-edicao-actions">


              <button
                type="button"

                className="
                    grupo-edicao-btn
                    grupo-edicao-btn-cancel
                  "

                onClick={() =>
                  navigate(-1)
                }
              >
                Cancelar
              </button>


              <button
                type="submit"

                className="
                    grupo-edicao-btn
                    grupo-edicao-btn-save
                  "

                disabled={
                  notificacoesSelecionadas.length === 0
                }
              >
                Salvar
              </button>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}


export default Grupo_edicao;